import type { TypedDocumentNode } from "@apollo/client/core";
import type { UrlParam } from "~/composables/useUrlParam";
import { MetricPeriodType } from "~/graphql/generated/graphql";

export const Operator = {
  Equals: "eq",
  GreaterThan: "gt",
  GreaterThanOrEqual: "gte",
  LessThan: "lt",
  LessThanOrEqual: "lte",
  In: "in",
  Contains: "ct",
  ContainsCaseInsensitive: "ict",
  StartsWith: "sw",
  StartsWithCaseInsensitive: "isw",
  EndsWith: "ew",
  EndsWithCaseInsensitive: "iew",
} as const;

export const toWritableRef = <T>(urlParam: UrlParam<T>) =>
  computed({
    get() {
      return urlParam.value.value;
    },
    set(newValue) {
      urlParam.setValue(newValue);
    },
  });

export const metricPeriodToMoment = {
  [MetricPeriodType.Monthly]: "month",
  [MetricPeriodType.Quarterly]: "quarter",
  [MetricPeriodType.Yearly]: "year",
} as const;

export const getQueryName = (doc: TypedDocumentNode<any, any>) => doc.definitions.find((d) => d.kind === "OperationDefinition")?.name?.value ?? "";
